import { http } from '@/shared/api'
import type { CreateTicketInput, Ticket, TicketMessage, TicketView } from '../model/types'

const ticketPath = (ticketId: string): string => `/app/tickets/${encodeURIComponent(ticketId)}`

/**
 * Обращения пользователя Mini App (БП-12). Чужое обращение — `404 TK-001`,
 * как несуществующее; заблокированному — `403 U-003` (его перехватывает
 * оболочка).
 */
export const ticketApi = {
  /**
   * Новое обращение. Подарок привязывается, только если он этого человека
   * (даритель или получатель): чужой бэкенд молча не привяжет.
   */
  create: async (input: CreateTicketInput): Promise<TicketView> =>
    (await http.post<TicketView>('/app/tickets', input)).data,

  /** Свои обращения, свежие сверху. */
  list: async (signal?: AbortSignal): Promise<Ticket[]> =>
    (await http.get<Ticket[]>('/app/tickets', { query: { limit: 50 }, signal })).data,

  /** Обращение с перепиской; внутренних заметок поддержки в ней нет. */
  get: async (ticketId: string, signal?: AbortSignal): Promise<TicketView> =>
    (await http.get<TicketView>(ticketPath(ticketId), { signal })).data,

  /** Ответ в своём обращении; решённое возвращается в работу, закрытое — `409 TK-003`. */
  reply: async (ticketId: string, text: string): Promise<TicketMessage> =>
    (await http.post<TicketMessage>(`${ticketPath(ticketId)}/messages`, { text })).data,
}
